import { useNavigate } from "react-router-dom";
import { useDarkMode } from "../../hooks/useDarkMode";

function Success() {
  const { isDark, toggle } = useDarkMode();
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const notificationId: string = queryParameters.get("id") ?? "";
  // PollDisplayer forwards whichever identifier opened the poll, so this page is
  // reached as either /success?id=<_id> or /success?shortlinkId=<code>. Reading only
  // "id" left the short-link case empty and sent "Go Back" to /answer?id= , which
  // 404s against get-status.
  const shortlinkId: string = queryParameters.get("shortlinkId") ?? "";
  const backPath = shortlinkId
    ? `/s/${encodeURIComponent(shortlinkId)}`
    : `/answer?id=${encodeURIComponent(notificationId)}`;

  return (
    <div className="min-h-screen bg-slate-100 dark:bg-gray-950 flex items-center justify-center py-8 px-4 transition-colors duration-200">
      {/* Dark mode toggle */}
      <button
        onClick={toggle}
        aria-label="Toggle dark mode"
        className="fixed top-4 right-4 z-50 p-2.5 rounded-full bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-150"
      >
        {isDark ? (
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        ) : (
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
          </svg>
        )}
      </button>

      <div className="w-full max-w-sm">
        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-md overflow-hidden transition-colors duration-200">
          <div className="h-1 bg-orange-500" />
          <div className="p-10 text-center font-latoRegular">
            <div className="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto mb-5">
              <svg className="w-8 h-8 text-green-500 dark:text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>

            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-2">
              All done!
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed mb-8">
              Your answer has been submitted successfully.
              <br />
              You can close this tab now.
            </p>

            <button
              type="button"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-500 hover:bg-orange-600 text-gray-900 text-sm font-semibold rounded-xl transition-colors duration-150"
              onClick={() => navigate(backPath)}
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Go Back
            </button>
          </div>
        </div>

        <p className="text-center text-xs text-gray-400 dark:text-gray-600 mt-4">
          Powered by AlertAware
        </p>
      </div>
    </div>
  );
}

export default Success;
